@if ((client.isL || client.isX) && gridMedia().length > 1) {
<button class="pos-absolute left-0 z-5 flex flex-middle flex-justify-center _icon"
        [attr.aria-label]="(productViewLayout.mediaLayoutGrid() ? 'View as grid' : 'View as scroll') | translate"
        (click)="handleMediaLayoutChange()">
    @if (productViewLayout.mediaLayoutGrid()) {
    <i class="icon-media-carousel"
       aria-hidden="true"></i>
    } @else {
    <i class="icon-media-grid"
       aria-hidden="true"></i>
    }
</button>
}
@if (productViewLayout.mediaLayoutGrid()) {
<div [grid]="4"
     [gridColumnGap]="'1px'"
     [gridRowGap]="'1px'">
    @for (item of gridMedia(); track $index) {
    <div class="overflow-hidden pos-relative"
         [class]="['photoswipe-galleryuid-' + parent().id]"
         [gridColumn]="getGridColSpan($index)"
         [gridRowSpan]="getGridRowSpan($index)">
        <ng-container *ngTemplateOutlet="itemTpl; context: { $implicit: item, index: $index }" />
    </div>
    }
</div>
} @else if (gridMedia().length > 1) {
<carousel class="fill z-2"
          [style.--carousel-slides-per-view-round]="1"
          [style.--carousel-slides-per-view]="1"
          [style.--carousel-space-between.px]="0"
          [loop]="true"
          [nested]="true"
          [pagination]="{
                dynamicBullets: true,
                clickable: true
            }"
          [mousewheel]="!client.isTouchy"
          [direction]="client.isL || client.isX ? 'vertical' : 'horizontal'"
          (afterInit)="handleAfterInit($event)">
    @for (item of gridMedia(); track $index) {
    <ng-template carouselSlide>
        <div class="overflow-hidden height-100 pos-relative"
             [class]="['photoswipe-galleryuid-' + parent().id]">
            <ng-container *ngTemplateOutlet="itemTpl; context: { $implicit: item, index: $index }" />
        </div>
    </ng-template>
    }
</carousel>
<!-- one image that is always visible under the carousel -->
@let item = gridMedia()[0];
@if (item) {
<div class="ratio-3-4 ratio-3-5-m ratio-3-5-s z-1 _placeholder">
    <div class="fill z-2 _placeholder-slide">
        <img class="z-3"
             [dfImage]="item.image"
             [ratio]="client.isL || client.isX ? 'ratio-3-4' : 'ratio-3-5'"
             [priority]="true"
             [alt]="product().data?.name || ''"
             [sizes]="getImageSizes(0)"
             [minSize]="256"
             [maxSize]="1080"
             fill>
    </div>
</div>
}
} @else {
@let item = gridMedia()[0];
<div class="ratio-3-4 ratio-3-5-m ratio-3-5-s overflow-hidden"
     [class]="['photoswipe-galleryuid-' + parent().id]">
    <ng-container *ngTemplateOutlet="itemTpl; context: { $implicit: item, index: 0 }" />
</div>
}

<!-- register images for photoswipe -->
@for (item of media(); track $index) {
<div class="ng-hide"
     [photoswipe]="item.image"
     [photoswipeUid]="item.image + '.' + parent().id + '.' + $index"
     [photoswipeOptions]="{
        index: parent().id + '.' + $index,
        galleryUID: parent().id,
        canPreload: true,
        loadAfterOpen: false
    }"></div>
}

<product-layout-media-lightbox [product]="product()"
                               [nativeElement]="nativeElement" />

<ng-template #itemTpl
             let-item
             let-index="index">
    <div class="z-1 ratio-3-4 ratio-3-5-m ratio-3-5-s _item">
        <custom-cursor class="fill pos-absolute-x pos-absolute-l pos-absolute-m pos-absolute-s z-2">
            <ng-template #customCursorContent>
                @if (item?.image) {
                <img class="z-3"
                     [dfImage]="item.image"
                     [ratio]="client.isL || client.isX ? 'ratio-3-4' : 'ratio-3-5'"
                     [priority]="true"
                     [alt]="product().data?.name || ''"
                     [sizes]="getImageSizes(index)"
                     [minSize]="256"
                     [maxSize]="1080"
                     [photoswipe]="item.image"
                     [photoswipeUid]="item.image + '.' + parent().id + '.' + index"
                     [photoswipeOptions]="{
                    index: parent().id + '.' + index,
                    galleryUID: parent().id,
                    canPreload: true,
                    loadAfterOpen: false
                }"
                     fill>
                }
                <!-- video -->
                @if (item?.video) {
                <local-vimeo-player class="fill z-4 bg-col-w"
                                    [video-url]="item.video"
                                    [background]="true"
                                    [autoplay-in-viewport]="true"
                                    [loop]="true" />
                }
            </ng-template>
            <ng-template #customCursorIcon>
                <svg xmlns="http://www.w3.org/2000/svg"
                     width="64"
                     height="64"
                     viewBox="0 0 16.933 16.933">
                    <path d="M63.95 32A31.95 31.95 0 0132 63.95 31.95 31.95 0 01.05 32 31.95 31.95 0 0132 .05 31.95 31.95 0 0163.95 32z"
                          transform="scale(.26458 .26459)"
                          fill="#fff"
                          fill-opacity=".94"
                          stroke="#999"
                          stroke-width=".1" />
                    <path d="M7.988 10.25V8.858H5.292v-.783h2.696V5.292h.87v2.783h2.784v.783H8.858v2.784h-.87z"
                          fill="#999" />
                </svg>
            </ng-template>
        </custom-cursor>
    </div>
</ng-template>